import styled from 'styled-components';
import { Banner as Banner_, FlexContainer } from '@taxdown/piccolo-web';
import ThreeColLayout_ from 'Components/Layouts/ThreeColLayout';
import { DESKTOP_WIDTH, MOBILE_WIDTH } from 'Styles/variables/sizes';

export const Container = styled(FlexContainer)`
  border: 1px solid ${({ theme: { colors } }) => colors.blue_5};
  padding-top: ${({ theme: { reference } }) => reference.dimension_16};
  border-radius: ${({ theme: { system } }) => system.fds_sys_borderradius_L};
  @media screen and (max-width: ${MOBILE_WIDTH}) {
    width: 100%;
  }
`;

export const WizardBox = styled(FlexContainer)`
  width: 450px;
  padding-bottom: ${({ theme: { reference } }) => reference.dimension_16};
  @media screen and (max-width: ${MOBILE_WIDTH}) {
    padding: 0;
    width: 100%;
  }
`;

export const Box = styled(FlexContainer)`
  padding: ${({ theme: { reference } }) => reference.dimension_16};
  width: 450px;
  @media screen and (max-width: ${MOBILE_WIDTH}) {
    width: 100%;
  }
`;

export const ThreeColLayout = styled(ThreeColLayout_)`
  @media screen and (max-width: ${DESKTOP_WIDTH}) {
    display: grid;
    grid-template-columns: 3fr;
    grid-column-gap: 30px;
    padding: 30px;
    height: 100%;
  }
`;

export const Banner = styled(Banner_)`
  width: 100%;
  margin-bottom: 10px;
`;
